import AxiosClient from '../plugins/axios';
import axios from 'axios';

export const sentenceLength = async (payload: any) => {
  return (
    await axios({
      url: `text/sentence-length`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const sentenceTemplates = async () => {
  const client = await AxiosClient();
  return (await client.get('iwriting/english_templates/', {}))?.data;
};

export const promptTemplates = async () => {
  const client = await AxiosClient();
  return (await client.get('iwriting/english_prompts/', {}))?.data;
};

export const paragraphLength = async (payload: any) => {
  return (
    await axios({
      url: `paragraph_len`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const transition = async (payload: any) => {
  return (
    await axios({
      url: `signal_transit`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};


export const transitConnectors = async () => {
  return (
    await axios({
      url: `transit_connectors`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: {}
    })
  )?.data;
};

export const generateText = async (payload: any) => {
  return (
    await axios({
      url: `text/generate`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const generateChat = async (payload: any) => {
  return (
    await axios({
      url: `text/chat-generate`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  );
};

export const reviewer = async (payload: any) => {
  return (
    await axios({
      url: `v5/text/reviewer`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  );
};

export const summarizeText = async (payload: any) => {
  return (
    await axios({
      url: `text/summarize`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const paraphraseText = async (payload: any) => {
  return (
    await axios({
      url: `text/paraphrase`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const v2SummarizeText = async (payload: any) => {
  return (
    await axios({
      url: `v2/text/summarize`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const v2ParaphraseText = async (payload: any) => {
  return (
    await axios({
      url: `v2/text/paraphrase`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const plagiarismChecker = async (payload: any) => {
  return (
    await axios({
      url: `text/plagiarism-checker`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'POST',
      data: payload
    })
  )?.data;
};

export const referenceSearch = async (query: any) => {
  return (
    await axios({
      url: `text/reference-search?${query}`,
      baseURL: process.env.API_AI_BASE_URL,
      method: 'GET',
      data: {}
    })
  )?.data;
};
